import { generalLink } from '@pkg/sanity-utils/linkQueries';
import groq from 'groq';

export const blockCTASectionFields = groq`
  ...,
  buttons[] {
    ...,
    link {
      ${generalLink}
    }
  }
`;
